import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EntryExit, OnOff } from './useInputOptions';

// Keep this list manually configured to maintain control over the properties associated with each ID.
// [ID(1-8), input(1/2), ON/OFF, entry/exit]
const outputOptions: [number, number, OnOff, EntryExit][] = [
  [1, 1, OnOff.On, EntryExit.Entry],
  [2, 1, OnOff.On, EntryExit.Exit],
  [3, 1, OnOff.Off, EntryExit.Entry],
  [4, 1, OnOff.Off, EntryExit.Exit],
  [5, 2, OnOff.On, EntryExit.Entry],
  [6, 2, OnOff.On, EntryExit.Exit],
  [7, 2, OnOff.Off, EntryExit.Entry],
  [8, 2, OnOff.Off, EntryExit.Exit],
];

export const useOutputOptions = (): DropdownItemProps<number>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return outputOptions.map(([id, output, onOrOff, entryOrExit]) => ({
      key: id.toString(),
      value: id,
      stringValue: id.toString(),
      label: t('OutputOption', { output, onOrOff, entryOrExit }),
    }));
  }, [t]);
};

export default useOutputOptions;
